import axios from 'axios';
export default {
    get(url, headers=this.default_headers()) {
        return axios.get(url, {headers: headers});
    },
    post(url, data, headers=this.default_headers()){
        return axios.post(url, data, {headers: headers});
    },
    post_file(url, data) {
        return axios.post(url, data, {
            headers:
                {
                    'Content-Type': 'application/json, multipart/form-data',
                    // 'Content-Type': 'multipart/form-data',
                    'Authorization': localStorage.getItem('token'),
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': '*',
                    'Access-Control-Allow-Headers': '*',
                    'crossDomain': true
                }
        });
    },
    //patch method for v2 webapi dashboard
    patch(url, data, headers=this.default_headers_v2()){
        return axios.patch(url, data, {headers: headers});
    },
    put(url, data, headers=this.default_headers()){
        return axios.put(url, data, {headers: headers});
    },
    delete(url, headers=this.default_headers()){
        return axios.delete(url, {headers: headers});
    },

    default_headers(){
        return {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('token'),
            'Access-Control-Allow-Origin': '*',
             'Access-Control-Allow-Methods': '*',
            'Access-Control-Allow-Headers': '*',
            'crossDomain': true
        }
    },
    default_headers_v2() {
        return {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('token'),
            'Access-Control-Allow-Origin': '*',
            'crossDomain': true,
            'accept-version': 2
        }
    }
}
